import { OrganizationCode } from 'merchandising-sdk';

const envOptions = {
  Dev: {
    WM: {
      Online: {
        production: false,
        organization: OrganizationCode.WM,
        is_online: true,
        data_git_repo: '',
        assets_url: 'https://stnailappdev.blob.core.windows.net/assets',
        local_db_name: 'merchandising.db',
      },
      Offline: {
        production: false,
        organization: OrganizationCode.WM,
        is_online: false,
        data_git_repo: 'https://developer:vidljbrv7nfji3fwp6dhg2z5bhg4susqdzchkbe7zx4m2epavcaq@dev.azure.com/AnalyticSmart/DevOps/_git/Merchandising-Data-Lop',
        assets_url: 'https://stnailappdev.blob.core.windows.net/assets',
        local_db_name: 'merchandising.db',
      }
    }
  }
};


export const environment = envOptions.Dev.WM.Online;